export default __webpack_public_path__ + "static/media/gu.2c9200ac.svg";